<template lang="pug">
el-form(ref='judgmentForm', :inline='true', :model='viewerJudgment', label-width='200px')
  el-form-item.compact-form-item(:label='gradeLabel()')
    | {{ application.grade }}
  br
  el-form-item.compact-form-item(v-if='application.grade_description' :label='gradeDescriptionLabel()')
    | {{ application.grade_description }}
  el-form-item(label=" " v-if="isReappraisal && workingApplication.overdue")
    el-alert(:closable="false", v-if="isReappraisal && workingApplication.overdue",
      type="warning", :title="OVERDUE_MESSAGE", show-icon="", style="border: 1px solid; background-color: #fdf6ec;")
  br
  el-form-item(label="Κατηγορία αίτησης" v-if="isReappraisal")
    el-switch(v-if="isReappraisal" disabled v-model="workingApplication.legalIssue"
      active-text="Νομικό ζήτημα" inactive-text="Ακαδημαϊκό ζήτημα")
  br(v-if="isReappraisal")
  el-form-item(label='Εσωτερικό Σχόλιο')
    el-input.biggest(type='textarea', :autosize='{ minRows: 4, maxRows: 10}',
      placeholder='Εισάγετε κείμενο για τον Πρόεδρο', v-model='viewerJudgment.comment',
      @change='modifycomment')
  el-form-item(label='Εισήγηση Δ/ντή Αναγν/σης',  v-if="fromConsultantSecOverdue")
    el-input.biggest(type='textarea', :autosize='{ minRows: 4, maxRows: 10}',
      placeholder='Εισάγετε την εισήγησή σας', v-model='viewerJudgment.proposal')
  proposals
  internalComments
  div(style='text-align: center')
    //- el-button(size='mini', type='primary', round='', @click='tempSave()', :disabled='false') Προσωρινή Αποθήκευση
    el-button(size='mini', type='danger', round='', @click='finalSave()', :disabled='false') Οριστική Υποβολή
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Proposals from '../common/Proposals'
import internalComments from '../common/internalComments'
import sharedMethods from '../common/sharedMethods.js'

export default {
  components: {
    Proposals,
    internalComments
  },
  mixins: [sharedMethods],
  mounted: function () {
  },
  props: ['application', 'comment'],
  data () {
    return {
      generalJudgment: '',
      appFinalSaved: false,
      modified: false,
      attachments: []
    }
  },
  methods: {
    gradeLabel () {
      if (this.isPostExam) {
        return 'Τελικός βαθμός (μετά από εξετάσεις)'
      }
      return 'Βαθμός πτυχίου'
    },
    gradeDescriptionLabel () {
      if (this.isPostExam) {
        return 'Χαρακτηρισμός (μετά από εξετάσεις)'
      }
      return 'Χαρακτηρισμός'
    },
    finalSave () {
      this.$confirm(`Η αίτηση προωθείται προς τον Πρόεδρο. Ειστε σίγουροι ότι θέλετε να συνεχίσετε;`,
        'Προειδοποίηση', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
        let finalJudgment = {
          internalComment: this.viewerJudgment.comment ? this.viewerJudgment.comment : ''
        }
        if (!this.isReappraisal) {
          finalJudgment = {
            ...finalJudgment,
            proposal: this.viewerJudgment.proposal ? this.viewerJudgment.proposal : null
          }
        }
        axios.put(
          `${this.BASE_URL}/processviewers/uid/applications/${this.workingApplication.id}/final`,
          {
            judgment: finalJudgment
          }
        ).then((response) => {
          this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
          this.frontEndSuccessMsg('Η αίτηση προωθήθηκε με επιτυχία')
        }).catch(err => {
          this.frontEndError('Σφάλμα κατά την οριστική αποθήκευση')
          this.catchError(err)
        })
      })
    },
    modifycomment (val) {
      this.modified = !(this.viewerJudgment.comment === this.comment)
    },
    catchError (err) {
      this.backendError(err)
      throw err
    }
  },
  computed: {
    isReappraisal () {
      return this.workingApplication.applicationType === 'reappraisal'
    },
    isPostExam () {
      return this.workingApplication.applicationType === 'compensatory'
    },
    viewerJudgment () {
      let h = this.application.applicationHistory
      return h[h.length - 1].judgment
      // .find(step => step.applicationStatus === 'viewerW_Proponent').judgment
    },
    fromConsultantSecOverdue () {
      // console.log(this.application.applicationHistory.slice(-1)[0].applicationStatus)
      return this.application.applicationHistory.slice(-1)[0].applicationStatus === 'viewerW_President'
    },
    // comment () {
    //   return this.viewerJudgment.comment
    // },
    ...mapState([
      'workingApplication',
      'BASE_URL',
      'activeLane',
      'OVERDUE_MESSAGE'
    ])
  },
  watch: {
    application: function (newVal, oldVal) {
      this.generalJudgment = this.comment
    },
    comment: {
      handler: function (newVal, oldVal) {
        this.generalJudgment = newVal
      },
      deep: true
    },
    // whenever value changes, this function will run
    pending: (newVal, oldVal) => {
      if (oldVal === true) this.comment = ''
    }
    // comment: (newComment, oldComment) => {
    //   if (newComment === 'the reason for pending') this.comment = ''
    // }
  }
}
</script>

<style scoped lang="scss">
.big {
  &.el-select {
    width: 450px;
  }
}
.biggest {
  &.el-textarea {
    width: 700px;
  }
}
.el-checkbox__label {
  background-color: transparent;
}

.el-form-item__content {
  line-height: 20px;
}
.el-form-item__label {
    text-align: right;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.el-form-item {
  color: rgb(30, 0, 128);
  font-weight: bold;
  padding-right: 20px;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/ViewerJudgment.vue